import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { ITextBoxProps } from './ITextBoxProps'
import clsx from 'clsx'
import { useTextBoxValidationSchema } from './TextBoxValidationSchema'

interface ISimpleTextBoxProps extends HTMLAttributes<HTMLInputElement>, ITextBoxProps { }

export const SimpleTextBox: FC<ISimpleTextBoxProps> = (props) => {
    const { id, placeholder, value: initValue, className, title, readOnly, disabled } = props
    const schema = useTextBoxValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<string>(initValue || '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setValue(inputValue)

        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <input
            id={id}
            title={title}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            value={value}
            onChange={handleChange}
        />
        {error && <FieldError show={true} message={error} />}
    </>
}
